import classNames from 'classnames';
import React from 'react';
import WixLogo from '../../WixLogo/WixLogo';
import styles from './CenteredLayout.scss';

interface IPageHeader {
  className?: string;
  children?: React.ReactNode;
}

const PageHeader: React.FC<IPageHeader> = ({ className, children }) => (
  <header className={classNames(styles.header, className)}>
    <WixLogo color="black" />
    {children}
  </header>
);
export default PageHeader;
